import 'core-js/es';
import 'react-app-polyfill/ie11';

import LuxonUtils from '@date-io/luxon';
import {MuiPickersUtilsProvider} from '@material-ui/pickers';
import {jssPreset, StylesProvider} from '@material-ui/styles';
import App from 'App';
import appHistory from 'appHistory';
import store, {enableReduxHMR} from 'configureStore';
import {ConnectedRouter} from 'connected-react-router';
import Authorize from 'Core/components/Authorize';
import {create} from 'jss';
import React from 'react';
import {render} from 'react-dom';
import {Provider} from 'react-redux';
import {Route} from 'react-router-dom';
import './index.sass';
import './Theme.sass';
import './datadog';

const jssProps: any = {...jssPreset(), insertionPoint: document.getElementById('jss-insertion-point')!};
const jss = create(jssProps);

export const renderApp = (AppComponent: typeof App) =>
  render(
    <StylesProvider jss={jss as any}>
      <Provider store={store}>
        <ConnectedRouter history={appHistory}>
          <MuiPickersUtilsProvider utils={LuxonUtils}>
            <Route exact path="/authorize" component={Authorize} />
            <AppComponent />
          </MuiPickersUtilsProvider>
        </ConnectedRouter>
      </Provider>
    </StylesProvider>,
    document.getElementById('root')
  );

// @ts-ignore
if (module.hot) {
  // @ts-ignore
  module.hot.accept('App', () => {
    const NextApp = require('App').default;
    renderApp(NextApp);
  });
}

renderApp(App);
